var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1437253030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "reminder-alert"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M84 42.001C84 65.1988 65.1975 84.0007 42.0007 84C18.8025 84.0007 5.26029e-08 65.1988 5.26029e-08 42.001C-0.00114838 18.8032 18.8025 0 42.0007 0C65.1975 0 84 18.8039 84 42.001Z",
    fill: "#0744E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.9532 43.8659C83.9337 43.8434 83.9142 43.8209 83.8929 43.7999C83.8563 43.7637 62.1196 22.0264 62.0737 21.9809C62.0373 21.9449 61.9966 21.9148 61.96 21.8791C61.9139 21.8328 61.875 21.7816 61.8286 21.7357C56.5343 16.4965 49.4555 13.6702 41.9801 13.8167C34.4282 13.9465 27.3213 16.9974 21.9696 22.4072C16.5821 27.8529 13.6869 34.9855 13.8167 42.4909C13.9478 50.0415 16.9153 57.0641 22.173 62.265C22.2101 62.3016 22.2513 62.3323 22.2884 62.3685C22.3337 62.414 22.3724 62.4648 22.4182 62.5101C22.4552 62.5467 43.8252 83.9062 43.8623 83.9426C43.8655 83.9459 43.8683 83.9497 43.8718 83.9529C65.581 83.0014 83.004 65.5766 83.9532 43.8659Z",
    fill: "#073ABB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.1783 70.38C26.6737 70.38 13.9883 57.6944 13.9883 42.19C13.9883 26.6855 26.6737 14 42.1783 14C57.6828 14 70.3682 26.6855 70.3682 42.19C70.3682 57.6944 57.6827 70.38 42.1783 70.38ZM42.1783 16.1685C27.8664 16.1685 16.1567 27.8781 16.1567 42.19C16.1567 56.5019 27.8664 68.2115 42.1783 68.2115C56.4902 68.2115 68.1997 56.5019 68.1997 42.19C68.1997 27.8781 56.49 16.1685 42.1783 16.1685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252966"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.4406 52.9624H42.3963C41.0443 52.9624 39.9647 54.1033 39.9887 55.4553C40.0115 56.7957 41.104 57.8648 42.4381 57.8648H42.4824C43.8345 57.8648 44.914 56.7239 44.89 55.3718C44.8661 54.0314 43.7749 52.9624 42.4406 52.9624Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M42.1829 55V54.9814M42.1829 49.4286C42.1829 41.0714 49.6115 42.9286 49.6115 36.4286C49.6115 32.3259 46.2855 29 42.1829 29C38.7214 29 35.8129 31.3674 34.9883 34.5714",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateAlert);
export default __webpack_public_path__ + "static/media/update-alert.74cdbd456a3b068cf69d0458d2fe4ecc.svg";
export { ForwardRef as ReactComponent };